var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7366 9.41399C14.6924 9.55845 14.6777 9.71033 14.6935 9.86059C14.7092 10.0108 14.7551 10.1564 14.8283 10.2885C14.9015 10.4207 15.0006 10.5367 15.1196 10.6298C15.2387 10.7228 15.3752 10.7909 15.5212 10.83C15.6671 10.8691 15.8194 10.8784 15.969 10.8573C16.1186 10.8363 16.2625 10.7853 16.3919 10.7075C16.5214 10.6297 16.6339 10.5266 16.7227 10.4043C16.8114 10.2821 16.8747 10.1432 16.9086 9.99597L18.6943 3.33584L18.9853 2.24985L17.8993 1.95886L11.2399 0.174488C10.9537 0.102967 10.6509 0.146711 10.3967 0.296296C10.1424 0.445882 9.9571 0.689341 9.88062 0.974238C9.80413 1.25913 9.84261 1.56267 9.98776 1.81948C10.1329 2.07628 10.3731 2.2658 10.6566 2.34722L14.6932 3.42882L1.21052 11.2131C0.952125 11.3623 0.763577 11.608 0.686354 11.8962C0.60913 12.1844 0.649557 12.4915 0.798741 12.7499C0.947926 13.0082 1.19365 13.1968 1.48185 13.274C1.77005 13.3512 2.07713 13.3108 2.33552 13.1616L15.8182 5.37738L14.7366 9.41399Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRedirect);
export default __webpack_public_path__ + "static/media/arrow-redirect.f1081f86ddc2423baa92dfe9bf763df1.svg";
export { ForwardRef as ReactComponent };